export const errorHandler = (err: any) =>
  err?.response?.data?.message
  || err?.response?.data?.msg
  || err?.message
  || 'Error';
